import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
	constructor() {
		this.FEE_EXPENSE = 300000;
		this.BOND_PERCENT = 0.3;
		this.highCR = .12;
		this.lowCR = .08;
		this.detailKeys = ["DA", "DM", "UC", "UM", "UA"];
	}
	/*public BalanceSheetItems_Bonds:Number = 0;
	public BalanceSheetItems_Loans:Number = 1;
	public BalanceSheetItems_Advances:Number = 2;
	public BalanceSheetItems_Deposits:Number = 3;
	public BalanceSheetItems_Equity:Number = 4;
	
	public BalanceSheetItemsDetails_Balance:Number = 0;
	public BalanceSheetItemsDetails_DA:Number = 1;
	public BalanceSheetItemsDetails_DM:Number = 2;
	public BalanceSheetItemsDetails_UN:Number = 3;
	public BalanceSheetItemsDetails_UM:Number = 4;
	public BalanceSheetItemsDetails_UA:Number = 5;
	public BalanceSheetItemsDetails_Actual:Number = 6;*/
	
	public detailKeys: string[];
	public FEE_EXPENSE:number;
	public BOND_PERCENT:number;
	
	public highCR:number;
	public lowCR:number;

	public brokerDefaultName = "(select from left)"; //"Welcome to Future Shape";
	public brokerDefaultDesc = "Welcome to the Future Shape Game, where you will select and allocate from multiple sectors to influence your bank's portfolio. The upper, left-hand corner of the screen lists the various sectors from which you can control and re-allocate percentages into your bank's portfolio. Naturally, you would like to learn more about the characteristics of these sectors. To see a brief description of each specific sector, please select and click on the link – a short description will be displayed on-screen.";
}


// WEBPACK FOOTER //
// ./src/app/game/globals.ts